import { useEffect, useState } from 'react';
import { api } from '../api';
import { sar } from '../format';

interface Bucket { bucket: '0-30' | '31-60' | '61-90' | '90+'; total: number; count: number }
interface Debtor { customer: string; outstanding: number; oldest_days: number }
interface Overdue { invoice: string; customer: string; amount: number; days_overdue: number }
interface Payload {
  lens: 'L05'; date: string;
  aging: Bucket[];
  top_debtors: Debtor[];
  overdue_this_week: Overdue[];
  total_ar: number;
  dso: number;
  _meta: { phase: number; mode: string; source: string };
}

const bucketStyle: Record<Bucket['bucket'], string> = {
  '0-30': 'u-info', '31-60': 'u-warn', '61-90': 'u-warn', '90+': 'u-critical',
};

export function LensReceivables() {
  const [data, setData] = useState<Payload | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => { api<Payload>('/lenses/L05').then(setData).catch((e) => setErr(String(e))); }, []);
  if (err) return <div className="lens error">خطأ: {err}</div>;
  if (!data) return <div className="lens">جارٍ التحميل…</div>;

  return (
    <div className="lens">
      <header>
        <h2>L05 — التحصيل</h2>
        <span className="badge">{data.date}</span>
        <span className="badge src">{data._meta.source}</span>
      </header>

      <section className="widgets">
        <div className="widget"><h3>إجمالي AR</h3><p className="big">{sar(data.total_ar)}</p><p className="hint">مستحق على العملاء</p></div>
        <div className="widget"><h3>DSO</h3><p className="big">{data.dso} يوم</p><p className="hint">Days Sales Outstanding</p></div>
        <div className="widget"><h3>متأخر هذا الأسبوع</h3><p className="big">{data.overdue_this_week.length}</p><p className="hint">يحتاج تذكير</p></div>
      </section>

      <section className="panel">
        <h3>Aging Buckets</h3>
        <div className="aging">
          {data.aging.map((b) => (
            <div key={b.bucket} className={`age-card ${bucketStyle[b.bucket]}`}>
              <p className="age-label">{b.bucket} يوم</p>
              <p className="age-total">{sar(b.total)}</p>
              <p className="age-count">{b.count} فاتورة</p>
            </div>
          ))}
        </div>
      </section>

      <section className="panel">
        <h3>أكبر المدينين</h3>
        <table className="banks">
          <thead><tr><th>العميل</th><th>المستحق</th><th>أقدم فاتورة</th></tr></thead>
          <tbody>
            {data.top_debtors.map((d) => (
              <tr key={d.customer}>
                <td>{d.customer}</td>
                <td className="num">{sar(d.outstanding)}</td>
                <td className="num">{d.oldest_days} يوم</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="panel">
        <h3>متأخّر هذا الأسبوع</h3>
        <ul className="cards">
          {data.overdue_this_week.map((o) => {
            const cls = o.days_overdue > 60 ? 'u-critical' : 'u-warn';
            return (
              <li key={o.invoice} className={`card ${cls}`}>
                <div className="card-head">
                  <span className={`pill ${cls}`}>{o.days_overdue} يوم</span>
                  <span className="lens-tag">{o.invoice}</span>
                  <span className="amount">{sar(o.amount)}</span>
                </div>
                <p className="card-title">{o.customer}</p>
              </li>
            );
          })}
        </ul>
      </section>
    </div>
  );
}
